import React, { useContext, useEffect, useMemo, useState } from "react";
import Tab, { TabGroup } from "@amzn/meridian/tab";
import Column from "@amzn/meridian/column";
import FlowView from "./Flow";
import IndirectHCView from "./IndirectHC";
import { FormattedMessage } from "react-intl";
import Row from "@amzn/meridian/row";
import OpsClockView from "./OpsClockView";
import { SettingsContext } from "./SettingsContext";
import Breaks from "./Breaks";
import { PermissionsContext } from "../../permissions/PermissionsContext";
import { logCustomMetric } from "../../overview/utils/utils";
import ResetTime from "./ResetTime";
import ShiftPlanAutomation from "./ShiftPlanAutomation";
import AmzlRosterManagement from "./AmzlRosterManagement";
import { getCountryCode } from "../../util/Util";
import { ROSTER_MANAGEMENT_ENABLED_COUNTRIES } from "../../util/Constants";

const AmzlSettingsSkeleton = () => {
  const [currentTab, setCurrentTab] = useState("opsClock");
  const { viewModel, dispatch } = useContext(SettingsContext);
  const { isUserAuthorisedForSettingsEdit } = useContext(PermissionsContext);

  const isShiftPlanAutomationEnabled = useMemo(() => {
    return (
      viewModel.triggerConfigurations &&
      viewModel.triggerConfigurations.length > 0
    );
  }, [viewModel]);

  const [isRosterManagementEnabled, setIsRosterManagementEnabled] =
    useState(false);

  useEffect(() => {
    const checkCountryCode = async () => {
      const result = await getCountryCode();
      const countryCode =
        result && result.locale ? JSON.parse(result.locale) : result;
      setIsRosterManagementEnabled(
        ROSTER_MANAGEMENT_ENABLED_COUNTRIES.includes(countryCode),
      );
    };
    checkCountryCode();
  }, []);

  useEffect(() => {
    let date = new Date().toISOString().substring(0, 10);
    dispatch({
      type: "LOAD_OPS_CLOCK_DATA",
      data: { dispatcher: dispatch, dispatchDate: date },
    });
    dispatch({
      type: "LOAD_BREAKS_DATA",
      data: { dispatcher: dispatch, dispatchDate: date },
    });
    dispatch({ type: "FETCH_CYCLE", data: { dispatcher: dispatch } });
    dispatch({ type: "FETCH_RESET_TIME", data: { dispatcher: dispatch } });
    dispatch({
      type: "LOAD_TRIGGER_CONFIGURATIONS",
      data: { dispatcher: dispatch },
    });
  }, []);

  return (
    <Row width="100%">
      <Column spacing="small" spacingInset="medium large none large">
        <TabGroup
          value={currentTab}
          onChange={(a) => {
            setCurrentTab(a);
            logCustomMetric("Tab Switch", a.toString());
          }}
          fill="line"
        >
          <Tab value="opsClock">
            <FormattedMessage
              id="settings.opsclock"
              defaultMessage="OPS Clock"
            />
          </Tab>
          <Tab value="breaks">
            <FormattedMessage id="settings.breaks" defaultMessage="Breaks" />
          </Tab>
          <Tab value="flow">
            <FormattedMessage
              id="settings.wipsettings"
              defaultMessage="WIP Settings"
            />
          </Tab>
          <Tab value="indirecthc">
            <FormattedMessage
              id="settings.indirecthc"
              defaultMessage="Indirect HC"
            />
          </Tab>
          <Tab value="resetTime">
            <FormattedMessage
              id="settings.resetTime"
              defaultMessage="Reset Time"
            />
          </Tab>
          {isShiftPlanAutomationEnabled && (
            <Tab value="shiftPlanAutomation">
              <FormattedMessage
                id="settings.shiftPlanAutomation"
                defaultMessage="Shift Plan Automation"
              />
            </Tab>
          )}
          {isRosterManagementEnabled && (
            <Tab value="amzlRosterManagement">
              <FormattedMessage
                id="settings.amzlRoster"
                defaultMessage="Roster"
              />
            </Tab>
          )}
        </TabGroup>
        {
          {
            flow: (
              <FlowView
                flow={{
                  processName: "flowData",
                  isUserAuthorisedForSettingsEdit:
                    isUserAuthorisedForSettingsEdit,
                }}
              />
            ),
            opsClock: (
              <OpsClockView
                props={{
                  isUserAuthorisedForSettingsEdit:
                    isUserAuthorisedForSettingsEdit,
                }}
              />
            ),
            breaks: (
              <Breaks
                props={{
                  isUserAuthorisedForSettingsEdit:
                    isUserAuthorisedForSettingsEdit,
                }}
              />
            ),
            indirecthc: (
              <IndirectHCView
                props={{
                  isUserAuthorisedForSettingsEdit:
                    isUserAuthorisedForSettingsEdit,
                }}
              />
            ),
            resetTime: (
              <ResetTime
                props={{
                  isUserAuthorisedForSettingsEdit:
                    isUserAuthorisedForSettingsEdit,
                }}
              />
            ),
            shiftPlanAutomation: (
              <ShiftPlanAutomation
                props={{
                  isUserAuthorisedForSettingsEdit:
                    isUserAuthorisedForSettingsEdit,
                }}
              />
            ),
            amzlRosterManagement: (
              <AmzlRosterManagement
                props={{
                  isUserAuthorisedForSettingsEdit:
                    isUserAuthorisedForSettingsEdit,
                }}
              />
            ),
          }[currentTab]
        }
      </Column>
    </Row>
  );
};

export default AmzlSettingsSkeleton;



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/AmzlSettingsSkeleton.js